<page-title text="BitOasis Pro | Trade crypto assets and fiat pairs in real time with advanced trading charts & order types" i18n-text="@@pageTitle.exchangeLanding"></page-title>
<page-meta
    description="Various order types and trading charts to utilize and enrich your trading experience. Highly liquid orderbook with swift execution of trading orders."
    i18n-description="@@pageMeta.description.exchange">
</page-meta>
<site-layout class="bg-black full">
  <div class="wrapper app-exchange">
    <section class="group-column">
      <div class="header-image">
        <img class="image header d-none d-md-block" src="assets/images/core/{{lang}}/pro-full.webp" alt="">
        <img class="d-md-none" src="assets/images/core/{{lang}}/pro-mobile.webp" alt="">
      </div>
      <div class="content-space">
        <h1 i18n="@@front.exchange.header.title">BitOasis Pro</h1>
        <p class="text-space" i18n="@@front.exchange.header.info">An advanced trading platform that puts you in control</p>
        <a *ngIf="!isLoggedIn" routerLink="/register" class="btn btn-primary btn-wide" i18n="@@front.exchange.header.btn">Try Pro now</a>
        <a *ngIf="isLoggedIn" routerLink="/pro" class="btn btn-primary btn-wide" i18n="@@front.exchange.header.btnIn">Go to Pro</a>
        <p class="mt-3" i18n="@@front.exchange.header.subinfo">Over $4 billion in trading volume and counting. Start trading within minutes.</p>
      </div>
    </section>
    
    <section class="group">
      <div class="content-space">
        <p class="label-green" i18n="@@front.exchange.section1.label">Extended crypto offering</p>
        <h2 i18n="@@front.exchange.section1.title">Over {{ (currencies$ | async)?.length  || 80 }} cryptocurrencies and 200 trading pairs</h2>
        <p i18n="@@front.exchange.section1.text">Trade and invest in the world's biggest cryptocurrencies with more than 200 trading pairs</p>
      </div>
      <img class="image" src="assets/images/pro/{{lang}}/coin-market.webp" alt="coin-market">
    </section>

    <section class="group group-reverse">
      <div class="content-space">
        <p class="label-green" i18n="@@front.exchange.section2.label">Advanced features</p>
        <h2 i18n="@@front.exchange.section2.title">Real-time price charts and indicators</h2>
        <p i18n="@@front.exchange.section2.text">Seamless order execution with our highly-liquid orderbooks.</p>
      </div>
      <div class="image-hidden">
        <img class="image" src="assets/images/pro/{{lang}}/price-chart.webp" alt="price-chart">
      </div>
    </section>

    <section class="group">
      <div class="content-space">
        <p class="label-green" i18n="@@front.exchange.section3.label">Low fees</p>
        <h2 i18n="@@front.exchange.section3.title">Most competitive trading fees in the MENA region</h2>
        <p i18n="@@front.exchange.section3.text">Our maker-taker fees are among the lowest in the region, and the more your trade, the lower your fees become. <a routerLink="/page/fees">Check our fees.</a></p>
      </div>
      <img class="image" src="assets/images/pro/{{lang}}/fees.webp" alt="fees">
    </section>

    <section class="group-column group-space">
      <h4 i18n="@@front.exchange.info.title">Join 100,000+ Pro traders.</h4>
      <a *ngIf="!isLoggedIn" routerLink="/register" class="btn btn-primary btn-wide" i18n="@@front.exchange.info.btn">Create an account</a>
      <a *ngIf="isLoggedIn" routerLink="/pro" class="btn btn-primary btn-wide" i18n="@@front.exchange.header.btnIn">Go to Pro</a>
      <p class="mt-3" *ngIf="!isLoggedIn">
        <span i18n="@@front.exchange.info.text">Already have an account?</span>&nbsp;
        <a routerLink="/login" i18n="@@front.exchange.info.link">Sign in</a>
      </p>
    </section>

    <section class="group group-green">
      <div class="phones-wrapper">
        <img class="image" src="assets/images/pro/{{lang}}/phones.webp" alt="phones">
      </div>
      <div class="content-space">
        <p class="text-bold" i18n="@@front.exchange.section4.label">Try BitOasis Lite</p>
        <h2 i18n="@@front.exchange.section4.title">Looking for an easier and faster way to buy crypto?</h2>
        <p i18n="@@front.exchange.section4.text">Try BitOasis Lite, our one-step trading tool for a simplified crypto experience.</p>
        <a *ngIf="!isLoggedIn" routerLink="/page/lite" class="btn btn-primary btn-wide custom-button" i18n="@@front.exchange.section4.btn">Learn More</a>
        <a *ngIf="isLoggedIn" routerLink="/lite" class="btn btn-primary btn-wide custom-button" i18n="@@front.exchange.section4.btnIn">Go to Lite</a>
        <p class="mt-3" *ngIf="!isLoggedIn">
          <span i18n="@@front.exchange.info.text">Already have an account?</span>&nbsp;
          <a routerLink="/login" i18n="@@front.exchange.info.link">Sign in</a>
        </p>

      </div>
    </section>
  </div><!-- .wrapper -->
</site-layout>
<site-footer></site-footer>
